export class AcsBulkDeleteState<T> {
  selectedIds: Set<number> = new Set();
  showConfirm: boolean = false;
  isDeleting: boolean = false;

  constructor(
    private _getIdFn: (item: T) => number,
    private _getItemsFn: () => T[]
  ) {}

  get selectedCount(): number { return this.selectedIds.size; }

  isSelected(id: number): boolean { return this.selectedIds.has(id); }

  toggle(id: number, event: Event): void {
    event.stopPropagation();
    if (this.selectedIds.has(id)) { this.selectedIds.delete(id); }
    else { this.selectedIds.add(id); }
    this.selectedIds = new Set(this.selectedIds);
  }

  get allVisibleSelected(): boolean {
    const items = this._getItemsFn();
    return items.length > 0 && items.every(item => this.selectedIds.has(this._getIdFn(item)));
  }

  toggleSelectAll(): void {
    const items = this._getItemsFn();
    if (this.allVisibleSelected) {
      for (const item of items) { this.selectedIds.delete(this._getIdFn(item)); }
    } else {
      for (const item of items) { this.selectedIds.add(this._getIdFn(item)); }
    }
    this.selectedIds = new Set(this.selectedIds);
  }

  requestDelete(): void { this.showConfirm = true; }
  cancelDelete(): void { this.showConfirm = false; }

  reset(): void {
    this.selectedIds = new Set();
    this.showConfirm = false;
    this.isDeleting = false;
  }
}
